<template>
  <button
    type="button"
    class="flex w-full min-h-40 px-16 py-8 items-center hover:bg-blue50"
    :class="isSelected ? 'text-brand-primary' : 'text-on-surface-elevation-1'"
    @click="$emit('onSelected', value)"
  >
    <st-tooltip-text-over
      :hasArrow="false"
      :content="content"
      position="bottom-start"
      :theme="'lnb-group-item-tooltip'"
      allowHTM
    >
      <span :class="isSelected ? 'font-bold' : 'font-medium'" class="break-all text-left line-clamp-1 text-md leading-sm pr-[0.1rem]">
        <slot></slot>
      </span>
    </st-tooltip-text-over>
    <s-icon v-if="hasOwnership" size="xl" icon="ic-v2-object-crown-fill" class="shrink-0 ml-4" />
    <s-new-badge v-if="isNew" variant="dot" class="shrink-0 ml-2 !bg-[#FC4420] self-start" />
  </button>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue';

import StTooltipTextOver from '@/components/common/st-tooltip-text-over.vue';

defineProps<{
  hasOwnership?: boolean;
  isNew?: boolean;
  isSelected: boolean;
  value: string;
}>();

defineEmits<{
  onSelected: [v: string];
}>();

const slots = useSlots();

const content = computed(() => {
  const children = slots.default?.({})[0]?.children;
  return typeof children === 'string' ? children as string : (children ? String(children) : '');
});
</script>
<style lang="scss">
.tippy-box[data-theme~='lnb-group-item-tooltip'] {
  .tippy-content {
    max-width: 21rem !important;
  }
}
</style>
